import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function dailyChartReducer() {
    return combineReducers({
        DailyChart_MonthList: createItemReducer("DailyChart", "Vacancy.ListTabCalMonth_NewPO", false),
        DailyChart_MonthListParams: createItemReducerParams("DailyChart", "Vacancy.ListTabCalMonth_NewPO"),
        DailyChart_YearList: createItemReducer("DailyChart", "Vacancy.ListTabCalYear_NewPO", false),
        WorkSchedule_MonthList: createItemReducer("DailyChart", "Vacancy.ListTabCalMonthPers_NewPO", false),
        WorkSchedule_MonthListParams: createItemReducerParams("DailyChart", "Vacancy.ListTabCalMonthPers_NewPO"),
        WorkSchedule_YearList: createItemReducer("DailyChart", "Vacancy.ListTabCalYear_NewPO", false),
        AppPers_ListForPO: createItemReducer("DailyChart", "AppPers.ListForPO", false),
        AppPers_ListTypeOnNewPO: createItemReducer("DailyChart", "AppPers.ListTypeOnNewPO", false),
        AppPers_New: createItemReducer("DailyChart", "AppPers.New", false),
        AppPers_Del: createItemReducer("DailyChart", "AppPers.Del", false),
        AppPers_GetWebTempl: createItemReducer("DailyChart", "AppPers.GetWebTempl", false),
        AppPers_GetWebData: createItemReducer("DailyChart", "AppPers.GetWebData", false),
        AppPers_Send: createItemReducer("DailyChart", "AppPers.Send", false),
        AppPers_GetWebDataList: createItemReducer("DailyChart", "AppPers.GetWebDataList", false),
        AppPers_CheckEmpty: createItemReducer("DailyChart", "AppPers.CheckEmpty", false)
    });
}